export enum ProceedToCheckoutClickEventActionTypeEnum {
    Action = 'Proceed To Checkout Clicked',
}

export enum ProceedToCheckoutEventLabelDestinationEnum {
    Addresses = 'Addresses',
    Authorization = 'Authorization',
    AccountExistenceCheck = 'Account existence check step',
    B2BOffers = 'Notification B2B only offer',
    InvalidOffers = 'Notification invalid offers'
}
